import SuiviAgences from "./SuiviAgences";

/**
 * Dashboard « Suivi courtier » — réutilise le composant Suivi agence, restreint aux
 * courtiers (endpoint dédié). Pas de vue matérialisée (volumétrie faible) → pas de
 * bouton « Rafraîchir ». Drill-down → détail agence (un courtier est une agence).
 */
const SuiviCourtiers = () => (
    <SuiviAgences
        apiPath="/api/agence/suivi-courtiers"
        refreshPath={null}
        pageTitle="Suivi courtier"
        pageSubtitle="CA, commissions et reversements par courtier"
        entityLabel="courtier"
        courtierMode
        // « Gérer » → liste des courtiers (fiches + import de la liste officielle).
        manageLink="/reseau/courtiers"
    />
);

export default SuiviCourtiers;
